<div>
    <div class="header">
        <div class="header-background">
            <div class="d-flex justify-content-between">
                <!-- Logo -->
                <div style="position: relative; z-index: 0;">
                    <img src="assets/images/register/Banner_Registro_phone.png" style="width: 100%;">
                </div>
            </div>
        </div>
    </div>

    <div id="allContent" class="background-default">
        <section id="wrapper">
            <div class="register">

                <div class="register-box" style="position: relative; z-index: 100;">
                    <div>
                        <!-- Title -->
                        <div class="p-b-16" *ngIf="showModifyPhone">
                            <span class="font-h5">Validá tu teléfono para personalizar tu experiencia. ¡Muchas gracias!</span><br>
                            <small class="text-muted">Te enviaremos un SMS con un código.</small>
                        </div>

                        <div *ngIf="!showModifyPhone">
                            <span class="font-h4" style="line-height: 30px !important;">Verificá tu teléfono</span><br>
                            <p class="font-c1 mt-3">
                                Ingresá el código de 6 dígitos que te enviamos por SMS a
                                <b> {{phone.value?.dialCode + ' ' +phone.value?.number}}.</b>
                                <b class="text-purple" (click)="changePhone()"> Modificar</b>
                            </p>
                        </div>

                        <form class="form-horizontal form-material" [formGroup]="formGroup" (ngSubmit)="onSubmit()" #formDir="ngForm">
                            <div *ngIf="showModifyPhone" [ngClass]="user?.phone?.length > 1 ? 'disable-info' :'' ">
                                <app-phone-input [formGroup]="formGroup" [label]="'Teléfono celular'"></app-phone-input>
                            </div>

                            <!-- codeConfirmation -->
                            <div *ngIf="!showModifyPhone">
                                <app-code-input [formGroup]="formGroup" [onReset]="onReset" [label]=""></app-code-input>

                                <div class="form-group m-t-24 text-center">
                                    <span class="text-muted font-c1">¿No recibiste el SMS?</span>
                                    <a class="font-b2 text-purple" href="javascript:void(0)" (click)="onVerifyPhone()"> Volver a enviar</a>
                                </div>
                            </div>

                            <!-- button Send Code -->
                            <div class="form-group m-t-24 text-center" *ngIf="showModifyPhone">
                                <button class="btn btn-primary btn-med w-100" type="button" [disabled]="!phone.valid" (click)="sendCode()">Enviar SMS</button>
                            </div>

                            <!-- button submit -->
                            <div class="form-group m-t-24 text-center" *ngIf="!showModifyPhone">
                                <button class="btn btn-primary btn-med w-100" type="submit" [disabled]="isInvalidCode()">Continuar</button>
                            </div>

                            <!-- Logout -->
                            <div class="p-t-8 p-b-8 text-center border-bottom" (click)="onLogout()" style="margin-bottom: 28%;">
                                <a class="text-purple font-c1 cursor-pointer">
                                    Salir
                                </a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>